// extracted by mini-css-extract-plugin
export default {"h1":"applications-components-common-Typography-typography-module__h1","h2":"applications-components-common-Typography-typography-module__h2","h3":"applications-components-common-Typography-typography-module__h3","largeP":"applications-components-common-Typography-typography-module__largeP","mainP":"applications-components-common-Typography-typography-module__mainP","smallP":"applications-components-common-Typography-typography-module__smallP"};
    if(module.hot) {
      // 1791528100688
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  